module.exports = __webpack_public_path__ + "img/chat.b31ed74f.png";